import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { environment } from 'src/environments/environment';

@Directive({
  selector: '[appCheckDomain]'
})
export class CheckDomainDirective {
  @Input('appCheckDomain') url: string = '';

  constructor(private el: ElementRef, private renderer: Renderer2) { }
  
  ngOnInit(): void {
    const domain = environment.flightConfig.apiUrl,
          src = this.el.nativeElement.getAttribute('src');
    if (src && !src.startsWith('http') && !src.startsWith(domain)) 
      this.renderer.setAttribute(this.el.nativeElement, 'src', domain + src);
  }
}
